var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcesimg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hugeicons:virtual-reality-vr-01"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 13H18M17 9H7C5.13 9 4.196 9 3.5 9.442C3.044 9.732 2.665 10.148 2.402 10.65C2 11.416 2 12.444 2 14.5C2 16.556 2 17.584 2.402 18.35C2.665 18.852 3.044 19.268 3.5 19.558C4.196 20 5.13 20 7 20C7.613 20 7.92 20 8.21 19.953C8.99895 19.8204 9.72701 19.4454 10.293 18.88C10.512 18.665 10.708 18.406 11.101 17.887L11.435 17.447C11.633 17.184 11.733 17.053 11.855 17.001C11.955 16.959 12.0665 16.9537 12.17 16.986C12.295 17.025 12.405 17.146 12.624 17.386L13.586 18.444C13.824 18.707 13.943 18.838 14.068 18.954C14.706 19.55 15.498 19.911 16.332 19.985C16.494 20 16.662 20 17 20C18.87 20 19.804 20 20.5 19.558C20.956 19.268 21.335 18.852 21.598 18.35C22 17.584 22 16.556 22 14.5C22 12.444 22 11.416 21.598 10.65C21.3437 10.1584 20.9652 9.74191 20.5 9.442C19.804 9 18.87 9 17 9Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22 15V12.452C22 11.472 22 10.982 21.923 10.509C21.8843 10.2761 21.8319 10.0457 21.766 9.819C21.633 9.364 21.427 8.944 21.015 8.104C20.188 6.419 19.775 5.577 19.172 5.011C18.8845 4.73981 18.5574 4.51389 18.202 4.341C17.495 4 16.692 4 15.084 4H8.916C7.309 4 6.506 4 5.799 4.34C5.44352 4.5132 5.11645 4.73945 4.829 5.011C4.227 5.577 3.813 6.419 2.986 8.104C2.574 8.944 2.368 9.364 2.235 9.819C2.16914 10.0457 2.11671 10.2761 2.078 10.509C2 10.982 2 11.472 2 12.452V15",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcesimg1);
export default __webpack_public_path__ + "static/media/procesimg1.1e05524373c8798a69ab1f1175f64abc.svg";
export { ForwardRef as ReactComponent };